document.addEventListener('alpine:init', () => {
    Alpine.data('verticalSteps', () => ({

        container: null,
        steps: null,
        shift: 0,

        init() {
            this.container = this.$refs.container;
            this.steps = this.container.querySelectorAll('.c-verticalSteps--step__bar--top');
            this.shift = window.innerHeight / 3; // Start animation in the upper 1/3 of the screen height

            this.resetSteps();

            window.addEventListener('scroll', () => {
                this.handleScroll();
            });
            window.addEventListener('resize', () => {
                this.handleScroll();
            });
        },
        resetSteps() {
            this.steps.forEach((element, index) => {
                element.style.height = '0';
            });
        },
        handleScroll() {
            let percent = 0;
            let stepsCount = this.steps.length;
            this.shift = window.innerHeight / 3; // update

            if (this.container.getBoundingClientRect().top - this.shift < 0) {
                let upperCenter = window.scrollY + this.container.getBoundingClientRect().top - this.shift + (window.innerHeight / 2);
                let scrollCenter = window.scrollY + (window.innerHeight / 2);
                let bottomCenter = window.scrollY + this.container.getBoundingClientRect().top + this.shift - (window.innerHeight / 2) + this.container.offsetHeight;
                percent = (scrollCenter - upperCenter) / (bottomCenter - upperCenter) * 100;

                this.steps.forEach((element, index) => {
                    if ((index + 1) * (100 / stepsCount) < percent) {
                        element.style.height = '100%';
                    } else if ((index) * (100 / stepsCount) < percent) {
                        let subPercent = (percent - (index) * (100 / stepsCount)) / (100 / stepsCount) * 100;
                        element.style.height = subPercent + '%';
                    } else {
                        element.style.height = '0';
                    }
                });
            } else {
                this.resetSteps();
            }
        }
    }));
});
